import { defineMessages } from 'react-intl';
export default defineMessages({
  openBtnAriaLabel: {
    id: "tsbob.OffCanvas.openBtnAriaLabel"
  },
  closeBtnAriaLabel: {
    id: "tsbob.OffCanvas.coleBtnAriaLabel"
  }
});